import sweetAlert from 'sweetalert2'
import moment from 'moment';
import { supplierspecialistService } from "../../Services/SupplierSpecialist.service";
import { supplierdentistsService } from "../../Services/SupplierDentists.service";
import { supplierlaboratoriesService } from "../../Services/SupplierLaboratories.service";
import { supplierinstitutionsService } from "../../Services/SupplierInstitutions.service";

export const myMixins = {
    data() {
        return {
            titleModal: '',
            showModal: false,
            modalUploadInvoice: false,
            modalMonthlyPayments: false,
            modalAgents: false,
            modalCard: false,
            modalStationery: false,
            modalSubsidiary: false,
            modalServices: false,
            modalSinisterAdmin: false,
            modalNotes: false,
            modalBills: false,
            modalForm: false,
            modalTicket: false,
            modalTicketQuoter: false,
            modalRenewQuoter: false,
            modalAddUser: false,
            complementInvoice: false,
            progress: 0,
            storageMapping: {
                2: '../storage/agentes',
                3: '../storage/ambulancias',
                4: '../storage/especialistas',
                5: '../storage/promotores',
                10: '../storage/laboratorios',
                11: '../storage/dentista',
                12: '../storage/radiologia',
                13: '../storage/optica',
            },
            columnMapping: {
                4: 'nom_com', 7: 'nm_prv_serv_med', 10: 'proveedor', 11: 'proveedor', 12: 'proveedor', 13: 'proveedor', // Agrega más casos según sea necesario
            },
            roleModels: {
                2: 'Agent',
                4: 'Specialist',
                5: 'Promoter',
                6: 'Client',
                7: 'Institution',
                8: 'AffiliateTitular',
                10: 'Laboratory',
                11: 'Dentist',
                12: 'Radiology',
                13: 'Optica',
            },
            alertMap: {
                warning: {
                    'no_match_files': 'Por favor, carga un archivo PDF y un archivo XML.',
                    'less_files': 'Por favor, carga exactamente dos archivos.',
                    'no_data': 'No hay registros.',
                    'no_employees': 'El número de empleados aún es cero.',
                    'no_quoter_complete': 'El precio por persona o el precio de gasto por persona no está definido en la cotización.',
                    'max_limit': 'El usuario alcanzó el máximo de servicio.',
                    'not_found': 'Al parecer no existe la abreviación de esta ciudad.',
                    'error_count': 'La tabla no tiene registros.',
                    'no_affiliate': 'El número de afiliados aún es 0, por favor, indica un número de afiliados.',
                    'maximum': 'El número de afiliados supera el mínimo permitido.',
                    'registered': 'El registro ya existe, intenta con uno diferente.',
                    'dependent_exists_sinisters': 'El dependiente tiene siniestros relacionados.',
                    'titular_exists_sinisters': 'El titular tiene siniestros relacionados.',
                }, success: {
                    'restored': 'Se ha restuarado al usuario.',
                    'mark_as_read': 'Se ha marcado como leída la notificación.',
                    'created_pdf': 'Se ha creado correctamente el PDF.',
                    'yes_service': 'Este usuario tiene servicio activo.',
                    'updated': 'El registro se actualizó correctamente.',
                    'success': 'El registro se guardo correctamente.',
                    'deleted': 'El registro se eliminó correctamente.',
                    'canceled': 'El usuario se canceló correctamente.',
                    'invoice_saved': 'Tu Factura se ha guardado correctamente.',
                    'confirm_payment': 'Su pago ha sido procesado exitosamente.',
                    'update_refund': 'Sus datos de reembolso se han guardado exitosamente.'
                }, error: {
                    'no_iva': 'Necesitas seleccionar el IVA para cotizar.',
                    'agent_quoting_existing': 'El agente no puede ser borrado del sistema por tener cotizaciones, solo se limitará el acceso al sistema.',
                    'invoice_rejected': 'Tu factura ha sido rechazada, no pasó la validación con el SAT.',
                    'no-picture': 'La imagen del afiliado no existe, vuelva a subirla.',
                    'error_picture': 'Algo salió mal, la imagen puede que el formato sea incorrecto o la imagen sea muy pesada.',
                    'fail': 'Algo salió mal, intenta de nuevo.',
                    'error_table': 'Algo salió mal, la tabla no existe.',
                    'prov_role_id': 'Tipo de Proveedor es requerido.',
                    'inst_id': 'Proveedor es requerido.',
                    'specialty_id': 'Especialidad es requerida.',
                    'type_serv': 'Tipo de Servicio es requerido.',
                    'fecha_atencion': 'Fecha de atención es requerido.',
                    'failConceptMismatch': 'La factura no cuenta con el concepto del SAT correcto.',
                    'city_exist_rel': 'La ciudad ya existe en el estado.',
                    'no_service': 'Lo sentimos, este usuario no tiene servicio activo.',
                    'get_invoice': 'Este registro ya tiene una factura. Solo puedes cargar un complemento para este registro.',
                    'no_msi': 'Selecciona un plan a MSI.',
                }
            },
        }
    }, methods: {
        accordionPanel(_panel) {
            let panel = document.getElementById(_panel);
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }

        }, detectDollar(val) {
            const regex = /^\$+/;

            // Prueba la cadena con la expresión regular y devuelve true si coincide, o false si no.
            return regex.test(val);
        }, disableSubmitBtn(flag) {
            let el = document.getElementById('dyn-button');
            if (flag) {
                el.innerText = "Procesando...";
                el.setAttribute('disabled', '');
            } else {
                el.innerText = "Guardar";
                el.removeAttribute('disabled');
            }
        }, formatDate(date) {
            let formatDate = '';
            if (date != null) {
                formatDate = moment(date).format('DD/MM/YYYY');
            }

            return formatDate;

        }, formatPrice(value) {
            if (this.detectDollar(value) === false) {
                //si el valor no tiene el signo de peso, lo agrega
                let val = (value / 1).toFixed(2).replace(',', '.')
                return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            } else {

                return value;
            }
        }, formatCurrency(price) {
            return Number(price).toLocaleString('en-US', {
                style: 'currency', currency: 'USD'
            })
        }, getAlert(getResponse, _reload = false) {
            //console.log('getResponse:', getResponse); // Agrega esta línea
            let specificAlert = '';
            let type = '';
            let _title = '';
            for (const key in this.alertMap) {
                if (this.alertMap[key].hasOwnProperty(getResponse)) {
                    specificAlert = this.alertMap[key][getResponse];
                    type = key;
                    _title = (type === 'success') ? '¡Enhorabuena!' : '¡Ups!';
                    break;
                }
            }
            //console.log('specificAlert:', specificAlert); // Agrega esta línea
            //console.info('specificAlert:', specificAlert, 'type:', type, 'title:', _title, 'reload:', _reload)
            if (specificAlert) {
                //console.log('title:', title, 'msg:', specificAlert, 'type:', type);
                this.showAlert(type, _title, specificAlert, _reload);
            } else {
                console.error('Respuesta no reconocida:', getResponse);
            }
        }, getHumanDate: function (date) {
            return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
        }, getNameFile(event, field) {
            let _fileData = event.target.files[0];
            let _ContainerFileName = document.querySelector('.' + field);
            _ContainerFileName.textContent = _fileData.name;
        }, imageToPrint(source) {
            return "<html><head><script>function step1(){\n" + "setTimeout('step2()', 10);}\n" + "function step2(){window.print();window.close()}\n" + "</scri" + "pt></head><body onload='step1()'>\n" + "<img src='" + source + "' /></body></html>";
        }, onUploadProgress(p) {
            this.progress = Math.round((p.loaded * 100) / p.total);
            //console.log(this.progress);
        }, openModalsProviders(modal) {
            this.showModal = true;
            switch (modal) {
                case 'admin_sinester':
                    this.modalSinisterAdmin = true;
                    break;
                case 'add_user':
                    this.titleModal = 'Agregar Usuario';
                    this.modalAddUser = true;
                    this.modalStationery = false;
                    this.modalNotes = false;
                    this.modalForm = false;
                    break;
                case 'card':
                    this.modalCard = true;
                    this.modalForm = false;
                    this.titleModal = 'Imprimir Credencial';
                    break;
                case 'upload_invoice':
                    this.modalUploadInvoice = true;
                    this.complementInvoice = false;
                    this.titleModal = 'Subir Factura';
                    break;
                case 'complement_invoice':
                    this.modalTicket = false;
                    this.modalUploadInvoice = false;
                    this.complementInvoice = true;
                    this.titleModal = 'Subir Complemento';
                    break;
                case 'invoice_quoter_promoter':
                case 'invoice_quoter_agent':
                case 'invoice_sinister':
                    this.modalBills = true;
                    this.modalTicketQuoter = false;
                    this.titleModal = 'Agregar Factura';
                    break;
                case 'renew_quoter':
                    this.titleModal = 'Renovar Cotización';
                    this.modalRenewQuoter = true;
                    this.modalTicketQuoter = false;
                    this.modalBills = false;
                    this.modalForm = false;
                    break;
                case 'listagents':
                    this.modalAgents = true;
                    this.modalStationery = false;
                    this.modalNotes = false;
                    this.titleModal = 'Lista de Agentes';
                    break;
                case 'monthly_payments':
                    this.titleModal = 'Pagos Mensuales';
                    this.modalMonthlyPayments = true;
                    this.modalNotes = false;
                    this.modalStationery = false;
                    this.modalForm = false;
                    break;
                case 'note':
                    this.modalAddUser = false;
                    this.modalAgents = false;
                    this.modalSubsidiary = false;
                    this.modalStationery = false;
                    this.modalForm = false;
                    this.modalServices = false;
                    this.modalNotes = true;
                    this.titleModal = 'Agregar Nota';
                    break;
                case 'payment_invoice':
                    this.complementInvoice = false;
                    this.modalTicket = true;
                    this.titleModal = 'Subir Pago a Factura';
                    break;
                case 'quoter':
                    //console.log('cotizador');
                    this.modalTicketQuoter = false;
                    this.modalBills = false;
                    this.modalForm = true;
                    this.titleModal = 'Cotizador';
                    break;
                case 'services':
                    this.modalSubsidiary = false;
                    this.modalForm = false;
                    this.modalTicket = false;
                    this.modalNotes = false;
                    this.modalServices = true;
                    this.titleModal = 'Servicios';
                    break;
                case 'stationery':
                    this.modalAddUser = false;
                    this.modalAgents = false;
                    this.modalSubsidiary = false;
                    this.modalNotes = false;
                    this.modalForm = false;
                    this.modalServices = false;
                    this.modalStationery = true;
                    this.titleModal = 'Subir Papelería';
                    break;
                case 'subsidiary':
                    this.modalStationery = false;
                    this.modalForm = false;
                    this.modalNotes = false;
                    this.modalServices = false;
                    this.modalSubsidiary = true;
                    this.titleModal = 'Agregar Sucursal';
                    break;
                case 'ticket_quoter':
                    this.modalForm = false;
                    this.modalTicketQuoter = true;
                    this.titleModal = 'Ticket Para Cotización';
                    break;
                case 'ticket_commission':
                    //console.log('cotizador');
                    this.modalForm = false;
                    this.modalTicketQuoter = true;
                    this.titleModal = 'Ticket Para Comisión';
                    break;
                case 'ticket':
                    this.modalForm = true;
                    this.titleModal = 'Formulario';
                    break;
                case 'upload_bill_admin':
                    this.modalSinisterAdmin = false;
                    this.modalTicket = false;
                    this.modalUploadInvoice = true;
                    this.titleModal = 'Agregar Factura';
                    break;
                default:
                    this.modalCard = false;
                    this.modalTicketQuoter = false;
                    this.modalSubsidiary = false;
                    this.modalTicket = false;
                    this.modalStationery = false;
                    this.modalServices = false;
                    this.modalForm = true;
                    this.modalNotes = false;
                    this.titleModal = 'Agregar Registro';
                    break;
            }
        }, parsePrice(value) {
            //SI el valor tiene el signo de peso
            if (this.detectDollar(value) === true) {
                // Remover el signo de peso y la coma
                // Retornar la cadena resultante
                return value.replace(/[,$]/g, '');
            } else {
                return value;
            }
        }, printImage(source) {
            let Pagelink = "about:blank";
            let pwa = window.open(Pagelink, "_new");
            pwa.document.open();
            pwa.document.write(this.imageToPrint(source));
            pwa.document.close();
            return false;
        }, processColumnNames(providers, columnName) {

            //console.log('providers', providers, 'columnName', columnName)

            // En otros casos, simplemente mapea los nombres de columna
            return providers.map(provider => ({
                id: provider.id,
                genericName: provider[columnName],
                relspecialistspecialty: provider.relspecialistspecialty ? provider.relspecialistspecialty.filter(specialty => specialty !== null) : [],
                relspecialistservices: provider.relspecialistservices ? provider.relspecialistservices.filter(service => service.service && service.service.servicio !== null) : []
            }));
        }, showAlert(kindAlert, title, msg, reload = false) {
            sweetAlert.fire({
                title: title, text: msg, icon: kindAlert
            }).then(function () {
                if (reload === true) {
                    location.reload();
                }
            })
        }, stateId($e) {
            let state_id = 0;
            if (typeof $e === 'object') {
                state_id = $e.target.options[$e.target.options.selectedIndex].value;
            } else {
                state_id = $e;
            }
            return state_id;
        }, validarEmail(email) {
            let expr = /^([a-zA-Z0-9_.\-])+@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            if (!expr.test(email))
                // alert("Error: La dirección de correo " + email + " es incorrecta.");
                return false;
        }, valFormulariosV3(form = null) {
            let _action = true;
            let _nameField = '';
            let inputs = '';

            if (form !== null) {
                const _form = document.querySelector('.' + form);
                inputs = _form.getElementsByClassName('required');
            } else {
                inputs = document.getElementsByClassName('required');
            }

            //let _this = this;

            let convertToArray = Array.from(inputs);

            for (let i = 0; i < convertToArray.length; i++) {
                let item = convertToArray[i];
                if (item.classList.contains('required')) {
                    if (item.getAttribute('type')) {
                        //console.log('type = ' + item.getAttribute('type'));
                        switch (item.getAttribute('type')) {
                            case 'hidden':
                            case 'text':
                            case 'tel':
                            case 'password':
                            case 'date':
                                if (item.value === undefined || item.value === '' || item.value === '0' || item.value.length === 0) {
                                    _nameField = item.getAttribute('placeholder');
                                    _action = false;
                                }
                                break;
                            case 'number':
                                //console.log('number = ' + item.value);
                                if (item.value === undefined || item.value === '') {
                                    _nameField = item.getAttribute('placeholder');
                                    _action = false;
                                }
                                break;
                            case 'email':
                                if (item.value === undefined || item.value === '' || item.value === '0' || item.value.length === 0) {
                                    if (this.validarEmail(item.value) === false) {
                                        _nameField = item.getAttribute('placeholder');
                                        _action = false;
                                    }
                                }
                                break;
                            case 'radio':
                            case 'checkbox':
                                if (item.checked === false) {
                                    _nameField = item.getAttribute('placeholder');
                                    _action = false;
                                }
                                break;
                            case 'file':
                                //console.log(item.files.length);
                                if (item.files.length === 0) {
                                    //_nameField = item.getAttribute('data-input-name');
                                    _nameField = item.dataset.nameInput;
                                    _action = false;
                                }
                                break;
                        }
                    } else {
                        if (item.dataset.select === 'on' || item.dataset.textarea === 'on') {
                            //console.log('Select/Textarea valor de item.value = ' + item.value);
                            if (item.value === undefined || item.value === '' || item.value === '0' || item.value === "-1") {
                                _nameField = item.dataset.nameInput;
                                console.log('Select/Textarea _nameField = ' + _nameField);
                                _action = false;
                                break;
                            }
                        }
                    }

                }//END IF CLASS REQUIRED

                //console.log(item, _action);
                if (_action === false) {
                    //console.log('haciendo el break');
                    break;
                }
            }//END FOR

            if (_action === true) {
                return true;
            } else {
                //console.log('Recogiendo el valor _nameField = ' + _nameField);
                return this.showAlert('error', '¡Ops!', _nameField);
            }

        }, async getProvidersByRole(id) {
            switch (Number(id)) {
                /* case 3:
                     return supplierambulancesService.getMany({});*/
                case 4:
                    return supplierspecialistService.getMany({});
                case 7:
                    return supplierinstitutionsService.getMany({});
                case 10:
                    return supplierlaboratoriesService.getMany({});
                case 11:
                    return supplierdentistsService.getMany({});
                /*case 12:
                    return supplierradiologyService.getMany({});
                case 13:
                    return supplieropticiansService.getMany({});*/
                default:
                    return [];
            }
        }, async selectCompanyByRoleProvider($e) {
            let id = this.stateId($e);
            let columnName = this.columnMapping[Number(id)];

            if (columnName) {
                let providers = await this.getProvidersByRole(id);
                // Procesa el nombre de la columna según sea necesario
                this.list_providers = this.processColumnNames(providers, columnName);
            }
        },

    }
}
